import { render, staticRenderFns } from "./HostsGridItem.vue?vue&type=template&id=0d6d626e&scoped=true&"
import script from "./HostsGridItem.vue?vue&type=script&lang=js&"
export * from "./HostsGridItem.vue?vue&type=script&lang=js&"
import style0 from "./HostsGridItem.vue?vue&type=style&index=0&id=0d6d626e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6d626e",
  null
  
)

export default component.exports